import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};
function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <a></a>
              <a></a> The rapidly depleting fossil fuel reserves with rising
              greenhouse gas levels (GHGs) in the atmosphere necessitate
              exploring alternate sustainable energy options. Biofuels from
              microalgae are emerging as a viable renewable energy resource
              owing to their inherent characteristics of higher biomass and
              lipid yield per hectare compared to other terrestrial bioenergy
              feedstocks. In this context, the present communication highlights
              the prospects of microalgal biofuel and other value-added products
              produced in a decentralized microalgal biorefinery in the flood
              plains (gazani lands) of the west coast of India. The spatial
              extent of potential sites for diatom cultivation estimated in
              three districts along the Indian west coast was 1940 ha. The
              opportunities for establishing biorefineries using diatoms as
              renewable bioenergy feedstocks were investigated through species
              prioritization, seasonal availability, tolerance, and biochemical
              composition analyses. <em>Nitzschia </em>and <em>Amphora </em>sp.
              were prioritized for lab-scale productivity studies based on their
              tolerance and macromolecular composition. When cultivated in a
              prototype biofilms-based bioreactor designed using gravel stones
              as substrates, <em>Amphora </em>sp. yielded 16 times more
              productivity (0.56 g L<sup>-1</sup>) than conventional shake flask
              cultures. Design of a diatom biorefinery and its mass budgeting
              considering 100 kg dry biomass yielded ~ 15 &ndash; 24 kg of
              biodiesel. Techno-economic assessment of biodiesel with
              value-added products of glycerol, biogas, and biofertilizer
              demonstrated a biodiesel production cost of 30.08 &ndash; 59.52
              INR/kg of biodiesel. Harvesting cost in a hybrid mode using
              mechanized scrubbers and manual labour was estimated as 20 INR/kg
              of biomass.
            </p>
            <p>
              <a></a>{" "}
              <span>
                <strong>Highlights </strong>
              </span>
            </p>
            <ul>
              <li>
                <p>
                  Evaluate the potential of diatoms as a source of biofuel with
                  value-added products.
                </p>
              </li>
              <li>
                <p>
                  Biochemical composition and feedstock availability assessment
                  across seasons.
                </p>
              </li>
              <li>
                <p>Design and implementation of prototype algal reactor.</p>
              </li>
              <li>
                <p>
                  Economic feasibility assessment and mass budgeting of the
                  diatom biorefinery.
                </p>
              </li>
              <li>
                <p>
                  Promising scope for a diatom biorefinery along the Indian
                  central west coast.
                </p>
              </li>
            </ul>
            <p>
              Keywords: diatoms; biofuel; bioreactor; microalgal refinery;
              techno-economic; lifecycle assessment; value-added products.
            </p>{" "}
            <br />
            <p style={{ textAlign: "center" }}>
              <strong>Abbreviations&nbsp; </strong>
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell}>
                    <p>GDP</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Gross Domestic Product</p>
                  </td>
                  <td style={styles.cell}>
                    <p>UCO</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Used cooking oil</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>GHG</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Greenhouse gas</p>
                  </td>
                  <td style={styles.cell}>
                    <p>FAME</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Fatty Acid Methyl Ester</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      CO<sub>2</sub>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Carbon dioxide</p>
                  </td>
                  <td style={styles.cell}>
                    <p>HTL</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Hydrothermal liquefaction</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>EBP</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Ethanol blending programme</p>
                  </td>
                  <td style={styles.cell}>
                    <p>&nbsp;3G</p>
                  </td>
                  <td style={styles.cell}>
                    <p>&nbsp;Third generation</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>NBM</p>
                  </td>
                  <td style={styles.cell}>
                    <p>National biodiesel mission</p>
                  </td>
                  <td style={styles.cell}>
                    <p>ABE</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Acetone-Butanol-Ethanol</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>SCO</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Single cell oil</p>
                  </td>
                  <td style={styles.cell}>
                    <p>TAG</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Triacylglycerol</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>ASP</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Aquatic Species Program</p>
                  </td>
                  <td style={styles.cell}>
                    <p>ICTGEB</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      International Centre for Genetic Engineering and
                      Biotechnology
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>MPB</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Microphytobenthos</p>
                  </td>
                  <td style={styles.cell}>
                    <p>C5</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Five carbon sugars</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>LC-PUFA</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Long-chain polyunsaturated fatty acid</p>
                  </td>
                  <td style={styles.cell}>
                    <p>MI</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Mission Innovation</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>&nbsp;DoE</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Department of Energy</p>
                  </td>
                  <td style={styles.cell}>
                    <p>IOC</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Indian Oil Corporation</p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={2} style={styles.cell}>
                    <p>EPS</p>
                  </td>
                  <td rowSpan={2} style={styles.cell}>
                    <p>Exopolysaccharides</p>
                  </td>
                  <td rowSpan={2} style={styles.cell}>
                    <p>IIT</p>
                    <p>COD</p>
                  </td>
                  <td rowSpan={2} style={styles.cell}>
                    <p>Indian Institute of Technology</p>
                    <p>Chemical Oxygen Demand</p>
                  </td>
                </tr>
                <br />
                <tr>
                  <td style={styles.cell}>
                    <p>ATS</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Algal Turf Scrubbers</p>
                  </td>
                  <td style={styles.cell}>
                    <p>HRT</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Hydraulic Retention Time</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>&nbsp;GoI</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Government of India</p>
                  </td>
                  <td style={styles.cell}>
                    <p>QGIS</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Quantum Geographic Information System</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>DBT</p>
                  </td>
                  <td style={styles.cell}>
                    <p>&nbsp;Department of Biotechnology</p>
                  </td>
                  <td style={styles.cell}>
                    <p>ISRO</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Indian Space Research Organisation</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>ICT</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Institute of Chemical Technology</p>
                  </td>
                  <td style={styles.cell}>
                    <p>NRDMS</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Natural Resources Data Management System</p>
                  </td>
                </tr>
              </tbody>
            </table>{" "}
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
